export default __webpack_public_path__ + "static/15_19-a71046e82f91ab5c5d2f8132dda3fe29.png";